import React, { useEffect, useState } from "react";
import useStyles from "./FmProductTitle.style";
import { useIsMobile } from "../../../../Hooks";
import { FarmerPractice } from "../../../../Models";
import { useAppSelector } from "../../../../Redux/Hooks/Hooks";
import { getMaxFarmerPractice } from "../../../../Utils/CalculateHelper";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

interface FmProductTitleProps {
  title: string;
  nutrients: FarmerPractice | null;
  unitValue: number;
  unitType: string;
  farmerPracrice?: FarmerPractice;
}

const FmProductTitle = ({ title, nutrients, unitValue, unitType, farmerPracrice }: FmProductTitleProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const isMobile = useIsMobile();
  const isSolutionUpdated = useAppSelector((state) => state.agriSolution.isSolutionUpdated);
  let updatedNpk: FarmerPractice | null = null;
  let updatedWeight: number | null = null;
  const showAlert = true; // Always show alert if changed

  if (isSolutionUpdated && nutrients != null) {
    const formulaNutrients: any = useAppSelector((state) => state.agriSolution.customizedState.formulaNutrients);
    const filteredKeys = Object.keys(nutrients).filter((key) => (formulaNutrients as any)[key] > 0);
    filteredKeys.sort((a, b) => (nutrients as any)[b] - (nutrients as any)[a]);
    let biggestNutrinetObject: { key?: string; value?: number } = {};

    // filteredKeys.forEach((key) => {
    //     (biggestNutrinetObject as any) = { key: key, value: (nutrients as any)[key] };
    // });

    (biggestNutrinetObject as any) = { key: filteredKeys[0], value: (nutrients as any)[filteredKeys[0]] };

    updatedWeight = Math.round(biggestNutrinetObject.value! / (formulaNutrients[biggestNutrinetObject.key!]! / 100));
    const newFormulaNutrients = Object.keys(formulaNutrients)
      .map((key) => {
        if (key == biggestNutrinetObject.key) return null;

        return {
          key,
          value: Math.round(((formulaNutrients as any)[key] / 100) * updatedWeight!),
        };
      })
      .filter((e) => e != null);

    newFormulaNutrients.push({
      key: biggestNutrinetObject.key!,
      value: biggestNutrinetObject.value!,
    });

    updatedNpk = {
      n: newFormulaNutrients.find((e) => e!.key == "n")?.value ?? null,
      p: newFormulaNutrients.find((e) => e!.key == "p")?.value ?? null,
      k: newFormulaNutrients.find((e) => e!.key == "k")?.value ?? null,
    };

    // if (updatedNpk.n! < 0.8 * nutrients.n!) {
    //     showAlert = true;
    // } else if (updatedNpk.p! < 0.8 * nutrients.p!) {
    //     showAlert = true;
    // } else if (updatedNpk.k! < 0.8 * nutrients.k!) {
    //     showAlert = true;
    // }

    console.log("[FmProductTitle isSolutionUpdated]", {
      formulaNutrients,
      updatedWeight,
      newFormulaNutrients,
      updatedNpk,
      nutrients,
      isSolutionUpdated,
      biggestNutrinetObject,
      filteredKeys,
    });
  }

  return (
    <div className={classes.container}>
      <div className={classes.mainTitle}>
        <span className={isMobile ? classes.mobile_title : classes.title}>{title}</span>
      </div>

      {updatedNpk != null && showAlert && (
        <div className={isMobile ? classes.mobile_npk : classes.npk}>
          <span>{`N ${updatedNpk.n}`}</span>
          <span style={{ marginLeft: 7 }}>{`P2O5 ${updatedNpk.p}`}</span>
          <span style={{ marginLeft: 7 }}>{`K2O ${updatedNpk.k}`}</span>
          <span style={{ marginLeft: 7 }}>{`${updatedWeight} ${unitType}`}</span>
        </div>
      )}

      {updatedNpk != null && showAlert ? (
        <Alert severity="warning" color="warning" sx={{ marginY: "10px" }}>
          <span style={{ fontSize: 18 }}>{t("agriSolution.npkAlert")}</span>
          <div className={isMobile ? classes.mobile_npk : classes.npk}>
            <span>{`N ${nutrients ? nutrients.n : 0}`}</span>
            <span style={{ marginLeft: 7 }}>{`P2O5 ${nutrients ? nutrients.p : 0}`}</span>
            <span style={{ marginLeft: 7 }}>{`K2O ${nutrients ? nutrients.k : 0}`}</span>
            <span style={{ marginLeft: 7 }}>{`${unitValue} ${unitType}`}</span>
          </div>
        </Alert>
      ) : (
        <div className={isMobile ? classes.mobile_npk : classes.npk}>
          <span>{`N ${nutrients ? nutrients.n : 0}`}</span>
          <span style={{ marginLeft: 7 }}>{`P2O5 ${nutrients ? nutrients.p : 0}`}</span>
          <span style={{ marginLeft: 7 }}>{`K2O ${nutrients ? nutrients.k : 0}`}</span>
          <span style={{ marginLeft: 7 }}>{`${unitValue} ${unitType}`}</span>
        </div>
      )}
    </div>
  );
};

export default FmProductTitle;
